import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34670eb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-card__card-title" }
const _hoisted_2 = ["href"]

import { IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonText, IonImg } from '@ionic/vue';
import NewsItem from '@/types/NewsItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsCard',
  props: {
    item: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { class: "news-card__card" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), { class: "news-card__card-header" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonImg), {
            class: "news-card__card-image",
            src: _ctx.item.imageUrl,
            style: _normalizeStyle(_ctx.item.imageStyle)
          }, null, 8, ["src", "style"])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), { class: "news-card__card-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardTitle), { class: "news-card__card-title-container" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.item.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonText), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.content), 1)
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            class: "news-card__card-link",
            href: _ctx.item.seeMoreLink,
            target: "_blank"
          }, _toDisplayString(_ctx.$t('news.cards.know_more_link_label')), 9, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})